import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const HomeView = () => {
  const { t } = useTranslation();

  const onEnterClick = () => {
    window.location.href = "/dashboard";
  };
  return (
    // <div className={"w-full h-full flex flex-col items-center"}>
    // <div
    //   className="flex w-full pr-24 h-screen justify-center items-center bg-cover"
    //   style={{ backgroundImage: "url('/login.png')" }}
    // >
    <div
      style={{ backgroundImage: "url('/login.png')" }}
      className="flex w-full h-screen justify-center items-center bg-cover"
    >
      <div className={"w-3/5 h-full flex justify-center items-start"}>
        <div className={"flex flex-col justify-center items-start mt-64 gap-6"}>
          <p className={"text-3xl"}>{t("welcomeToSama")}</p>
          <p className={"text-base"}>{t("clickOnEnterToContinue")}</p>
        </div>
      </div>
      <div className={"w-2/5 h-full flex justify-center items-center"}>
        <div
          className={
            "w-[260px] rounded-xl bg-gray-30 hover:bg-primary-80 hover:text-gray-white cursor-pointer h-11 flex justify-center items-center text-base font-medium"
          }
          onClick={onEnterClick}
        >
          {t("enter")}
        </div>
      </div>
    </div>
  );
};

export default HomeView;
